module.exports = __webpack_public_path__ + "img/hologram-map-background-yellow.c2ea129a.svg";